import { render, staticRenderFns } from "./PixabayVideoComponent.vue?vue&type=template&id=6596bf6e&scoped=true&"
import script from "./PixabayVideoComponent.vue?vue&type=script&lang=js&"
export * from "./PixabayVideoComponent.vue?vue&type=script&lang=js&"
import style0 from "./PixabayVideoComponent.vue?vue&type=style&index=0&id=6596bf6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6596bf6e",
  null
  
)

export default component.exports